import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-inbox',
  templateUrl: './ai-inbox.component.html',
  styleUrls: ['./ai-inbox.component.scss']
})
export class AiInboxComponent {

}
